import styled from "styled-components";

export const EmptyStateStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;

  .empty_icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .empty_title {
    font-family: ${({ theme }) => theme.FONT.STYLE.MEDIUM};
    font-size: ${({ theme }) => theme.FONT.SIZE.S18};
    color: ${({ theme }) => theme.COLORS.BLACK_3};
  }

  .empty_sub {
    font-family: ${({ theme }) => theme.FONT.STYLE.REGULAR};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    color: ${({ theme }) => theme.COLORS.GRAY_4};
    max-width: 360px;
    text-align: center;
    line-height: 1.5;
  }
`;
